module.exports = __webpack_public_path__ + "static/media/other.51bb6ced.jpeg";